<template>
  <a-cascader :options="option ? option : props.options" expand-trigger="hover" :value="value" @change="change"
    allowClear :maxTagCount="3" :show-search="{ filter }" change-on-select multiple class="my-cascader" />
</template>
<script setup>
import { ref, defineProps, defineEmits, watchEffect, watch, useAttrs } from 'vue';
const props = defineProps({
  modelValue: {},
  url: {
    type: [Function],
  },
  params: {
    type: [Object],
    default: () => ({})
  },
  onSetOptions: {
    type: [Function],
  },
  options: {
    type: [Array],
    default: () => []
  },
  //表单嵌入弹出框时候使用 使得每次打开弹窗时重新调用接口来获取数据
  show: {
    type: [Boolean],
    default: true,
  },
  value1: {},
});

const emits = defineEmits(['update:modelValue', 'change', 'update:value1', 'update:value2']);
const value = ref([]);
const option = ref(false);
const attrs = useAttrs();
const change = (value, selectedOptions) => {
  emits('change', value, selectedOptions);
  emits('update:modelValue', value);
  emits('update:value1', value);
  emits('update:value2', selectedOptions);
}
const init = (fun = props.url, params = props.params) => {
  fun(params).then(res => {
    if (props.onSetOptions) {
      option.value = props.onSetOptions(res);
    } else {
      option.value = res.data.records ? res.data.records : res.data;
    }
  })
};
watch(() => props.modelValue, v => {
  value.value = v || [];
}, { immediate: true });
watch(() => props.value1, v => {
  value.value = v || [];
}, { immediate: true });
watchEffect(() => {
  props.show && props.url && init(props.url, props.params);
});

const filter = (inputValue, path) => {
  //console.log(path)
  return path.some(option => option[attrs.fieldNames?.label || 'label'].toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
};
// 向父级抛出的属性 方法
defineExpose({
  init,
});

</script>
<style scoped>
.my-cascader {
  min-width: 320px;
}
</style>
